const initialState = {
  agencyId: null,
  campaignId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_BATCH_AGENCY':
      return { ...state, agencyId: action.payload };
    case 'SET_BATCH_CAMPAIGN':
      return { ...state, campaignId: action.payload };
    default:
      return state;
  }
};
